import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffPayrollResponsibleRequest,
  StaffPayrollResponsibleResponse,
} from "../model/payroll-responsible.model";

@Injectable({ providedIn: "root" })
export class StaffPayrollResponsiblesService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) organizationBasePath: string,
  ) {
    this.url = `${organizationBasePath.replace(/\/$/, "")}/api/v1/payroll-responsibles`;
  }

  list(filters?: {
    companyId?: number;
    status?: string;
  }): Observable<StaffPayrollResponsibleResponse[]> {
    let params = new HttpParams();
    if (filters?.companyId != null)
      params = params.set("companyId", filters.companyId);
    if (filters?.status) params = params.set("status", filters.status);
    return this.http.get<StaffPayrollResponsibleResponse[]>(this.url, {
      params,
    });
  }

  getById(id: number): Observable<StaffPayrollResponsibleResponse> {
    return this.http.get<StaffPayrollResponsibleResponse>(`${this.url}/${id}`);
  }

  create(
    request: StaffPayrollResponsibleRequest,
  ): Observable<StaffPayrollResponsibleResponse> {
    return this.http.post<StaffPayrollResponsibleResponse>(this.url, request);
  }

  update(
    id: number,
    request: StaffPayrollResponsibleRequest,
  ): Observable<StaffPayrollResponsibleResponse> {
    return this.http.put<StaffPayrollResponsibleResponse>(
      `${this.url}/${id}`,
      request,
    );
  }

  setStatus(
    id: number,
    active: boolean,
  ): Observable<StaffPayrollResponsibleResponse> {
    return this.http.patch<StaffPayrollResponsibleResponse>(
      `${this.url}/${id}/status`,
      { active },
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
